import NativeVideo from './NativeVideo';

const initNativeVideos = () => {
  let videos = document.getElementsByTagName('video');
  for(let video of videos) {
    new NativeVideo(video);
  }
}

initNativeVideos();


// WEBPACK FOOTER //
// ./ui/assets/js/NativeVideo/init.js